module.exports = __webpack_public_path__ + "static/media/cancel.f4bb5dd0.svg";